export enum RegionEnum {
  EU = 'EU',
  SA = 'SA',
  NA = 'NA',
  AF = 'AF',
  AS = 'AS',
}